import { forwardRef, type HTMLAttributes, type MouseEventHandler, type ReactNode, type Ref } from 'react';
import { cn } from '../../utils/cn';
import { TONE_CLASSES, type Tone } from './toneStyles';

export type ChipTone = Tone;

export interface ChipProps extends Omit<HTMLAttributes<HTMLElement>, 'color'> {
    tone?: ChipTone;
    leadingIcon?: ReactNode;
    onClick?: MouseEventHandler<HTMLElement>;
    children?: ReactNode;
}

const BASE_CLASSES =
    'inline-flex items-center gap-1.5 bg-surface-chip border border-white/[0.08] rounded-chip px-2.5 py-1 text-label';

export const Chip = forwardRef<HTMLButtonElement | HTMLSpanElement, ChipProps>(function Chip(
    { tone = 'neutral', leadingIcon, onClick, className, children, ...rest },
    ref,
) {
    const classes = cn(BASE_CLASSES, TONE_CLASSES[tone].text, className);

    if (onClick) {
        return (
            <button
                ref={ref as Ref<HTMLButtonElement>}
                type="button"
                onClick={onClick}
                className={classes}
                {...(rest as HTMLAttributes<HTMLButtonElement>)}
            >
                {leadingIcon}
                {children}
            </button>
        );
    }

    return (
        <span ref={ref as Ref<HTMLSpanElement>} className={classes} {...rest}>
            {leadingIcon}
            {children}
        </span>
    );
});

export default Chip;
